import Transform from './Base';

export default class VenuesTransform extends Transform {
  /**
   * Method used to transform fetched venues.
   *
   * @param venue The fetched venue.
   *
   * @returns {Object} The transformed venue.
   */
  static fetch(venue) {
    return {
      city: venue.city || '',
      country: venue.country || '',
      id: venue._id,
      venue_name: venue.venue_name,
      field_length: venue.field_length,
      field_width: venue.field_width,
    };
  }
}
